import { IMessagesState } from "./messages.types";

export const initialMessagesState: IMessagesState = {
  item: null,
  saveLoader: 0,
  convertLoader: false,
  loader_with_message: {
    loading: false,
  },
};
